/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M14.25 7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM11.7803 6.5303a.75.75 0 0 0-1.0606-1.0606L8.25 7.9393l-.9697-.9696a.75.75 0 0 0-1.0606 1.0606L8.25 10.0607l3.5303-3.5304ZM14.25 15a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM11.7803 14.0303a.75.75 0 0 0 0-1.0606.75.75 0 0 0-1.0606 0L8.25 15.4393l-.9697-.9696a.75.75 0 0 0-1.0606 1.0606L8.25 17.5607l3.5303-3.5304Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.25 0C2.7647 0 .75 2.0147.75 4.5v15c0 2.4853 2.0147 4.5 4.5 4.5h13.5c2.4853 0 4.5-2.0147 4.5-4.5v-15c0-2.4853-2.0147-4.5-4.5-4.5H5.25Zm13.5 1.5H5.25c-1.6568 0-3 1.3432-3 3v15c0 1.6569 1.3432 3 3 3h13.5c1.6569 0 3-1.3431 3-3v-15c0-1.6568-1.3431-3-3-3Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Tasks'
);
